export const initialState = {
  listLoading: false,
  listError: null,
  loading: false,
  error: null,
  consultation: {},
  consultations: [],
  nextToken: null,
  nextTokens: { 1: null },
  nextLoading: false,
  messageLoading: false,
  messageError: null,
  messageRequest: null,
  messages: [],
  editedMessage: {},
  messageNextToken: null,
  messageNextLoading: false,
  messageNextError: null,
  sendLoading: false,
  sendError: null,
  incomingLoading: false,
  incomingError: null,
  callDialog: false,
  ongoingCall: "",
  services: [],
  serviceLoading: false,
  serviceError: null,
  sendDraftStatus: "",
  consultationID: "",
  submitLoading: false,
  submitError: null,
  request: null,
  zoomTokenLoading: false,
  zoomTokenError: null,
  zoomTokenData: null,
  rtkTokenLoading: false,
  rtkTokenError: null,
  rtkTokenData: null,
  ongoingConsultations: [],
  ongoingLoading: false,
  ongoingError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_GET_CONSULTATION":
      return {
        ...state,
        request: action.payload.request,
        loading: true,
        consultation: {},
        messages: [],
        error: null,
      };
    case "SUCCESS_GET_CONSULTATION":
      return {
        ...state,
        request: null,
        loading: false,
        consultation: action.payload.consultation,
      };
    case "ERROR_GET_CONSULTATION":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.error,
      };
    case "ERROR_GET_CONSULTATION_SILENT":
      return {
        ...state,
        loading: false,
      };
    case "REQUEST_LIST_CONSULTATION":
      return {
        ...state,
        listLoading: true,
        listError: null,
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        messageNextError: null,
      };
    case "REQUEST_MORE_CONSULTATIONS":
      return {
        ...state,
        nextLoading: true,
        listError: null,
        nextError: null,
      };
    case "SUCCESS_LIST_CONSULTATION":
      return {
        ...state,
        listLoading: false,
        nextLoading: false,
        consultations: action.payload.append
          ? [...state.consultations, ...action.payload.items]
          : action.payload.items,
        nextToken: action.payload.nextToken,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
      };
    case "ERROR_LIST_CONSULTATION":
      return {
        ...state,
        listLoading: false,
        nextLoading: false,
        listError: action.error,
      };
    case "REQUEST_ONGOING_CONSULTATIONS":
      return {
        ...state,
        ongoingLoading: true,
        ongoingError: null,
      };
    case "SUCCESS_ONGOING_CONSULTATIONS":
      return {
        ...state,
        ongoingLoading: false,
        ongoingConsultations: action.payload.items,
      };
    case "ERROR_ONGOING_CONSULTATIONS":
      return {
        ...state,
        ongoingLoading: false,
        ongoingError: action.error,
      };
    case "CLEAR_ONGOING_CONSULTATIONS":
      return {
        ...state,
        ongoingConsultations: [],
        ongoingLoading: false,
        ongoingError: null,
      };
    case "RESET_CONSULTATIONS":
      return {
        ...state,
        consultations: [],
        nextTokens: initialState.nextTokens,
      };
    case "RESET_ERROR_CONSULTATION":
      return {
        ...state,
        listError: null,
        nextError: null,
      };
    case "REQUEST_LIST_MESSAGE":
      return {
        ...state,
        listMessageRequest: action.payload.listMessageRequest,
        messageLoading: true,
        messageError: null,
        messageNextError: null,
        messages: [],
        messageNextToken: null,
      };
    case "SUCCESS_LIST_MESSAGE":
      return {
        ...state,
        listMessageRequest: null,
        messageLoading: false,
        messages: action.payload.items,
        messageNextToken: action.payload.nextToken,
      };
    case "ERROR_LIST_MESSAGE":
      return {
        ...state,
        listMessageRequest: null,
        messageLoading: false,
        messageError: action.error,
      };
    case "SUCCESS_LIST_MESSAGE_SILENT":
      let newMessages = [];
      const currentMessages = state.messages;
      const updatedMessages = action.payload.items || [];

      if (
        currentMessages.length === updatedMessages.length &&
        currentMessages.length > 1
      ) {
        if (
          currentMessages[currentMessages.length - 1].id ===
          updatedMessages[updatedMessages.length - 1].id
        ) {
          return state;
        }
      }

      for (let i = 0; i < updatedMessages.length; i++) {
        let exist = false;
        const message = updatedMessages[i];
        for (let j = currentMessages.length - 1; j >= 0; j--) {
          const currentMessage = currentMessages[j];
          if (currentMessage.id === message.id) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          newMessages.push(message);
        }
      }

      let allMessages = [...currentMessages, ...newMessages];

      if (
        currentMessages.length === allMessages.length &&
        currentMessages.length > 1
      ) {
        if (
          currentMessages[currentMessages.length - 1].id ===
          allMessages[allMessages.length - 1].id
        ) {
          return state;
        }
      }

      allMessages = allMessages.sort((a, b) => a.createdAt - b.createdAt);

      return {
        ...state,
        messages: allMessages,
      };
    case "REQUEST_LIST_NEXT_MESSAGE":
      return {
        ...state,
        messageNextLoading: true,
        messageNextError: null,
      };
    case "SUCCESS_LIST_NEXT_MESSAGE":
      return {
        ...state,
        messageNextLoading: false,
        messages: [...action.payload.items, ...state.messages],
        messageNextToken: action.payload.nextToken,
      };
    case "ERROR_LIST_NEXT_MESSAGE":
      return {
        ...state,
        messageNextLoading: false,
        messageNextError: action.error,
      };
    case "SEND_MESSAGE":
      return {
        ...state,
        sendLoading: true,
        sendError: null,
      };
    case "SUCCESS_SEND_MESSAGE":
      return {
        ...state,
        sendLoading: false,
        messages: [...state.messages, action.payload.message],
        sendDraftStatus: "SUCCESS",
      };
    case "ERROR_SEND_MESSAGE":
      return {
        ...state,
        sendLoading: false,
        sendError: action.error,
      };
    case "EDIT_MESSAGE":
      return {
        ...state,
        messageRequest: action.payload.request,
        editedMessage: {},
        sendLoading: true,
        sendError: null,
      };
    case "EDIT_MESSAGE_SUCCESS": {
      const { consultationID, message } = action.payload;

      return {
        ...state,
        messageRequest: null,
        editedMessage: message,
        // Update messages list
        messages:
          state.consultation?.id === consultationID
            ? state.messages.map((msg) =>
                msg.id === message.id ? { ...msg, ...message } : msg,
              )
            : state.messages,

        sendLoading: false,
      };
    }
    case "EDIT_MESSAGE_ERROR":
      return {
        ...state,
        messageRequest: null,
        sendLoading: false,
        sendError: action.error,
      };
    case "INCOMING_MESSAGE":
      return {
        ...state,
        incomingLoading: true,
        incomingError: null,
      };
    case "SUCCESS_INCOMING_MESSAGE":
      if (action.payload.id === state.consultation.id) {
        return {
          ...state,
          incomingLoading: false,
          messages: [...state.messages, action.payload.message],
        };
      }
      return state;
    case "ERROR_INCOMING_MESSAGE":
      return {
        ...state,
        incomingLoading: false,
        incomingError: action.error,
      };
    case "UPDATE_FIREBASE_MESSAGE": {
      const { consultationID, message } = action.payload;

      return {
        ...state,
        messages:
          state.consultation?.id === consultationID
            ? state.messages.map((msg) =>
                msg.id === message.id ? { ...msg, ...message } : msg,
              )
            : state.messages,
      };
    }
    case "SET_ONGOING_CALL":
      return {
        ...state,
        ongoingCall: action.payload.id,
      };
    case "SET_CALL_DIALOG":
      return {
        ...state,
        callDialog: action.payload.callDialog,
      };
    case "REQUEST_LIST_SERVICE":
      return {
        ...state,
        serviceLoading: true,
        serviceError: null,
        services: [],
      };
    case "SUCCESS_LIST_SERVICE":
      return {
        ...state,
        serviceLoading: false,
        services: action.payload.items,
      };
    case "ERROR_LIST_SERVICE":
      return {
        ...state,
        serviceLoading: false,
        serviceError: action.error,
      };
    case "REQUEST_UPDATE_CONSULTATION":
      return {
        ...state,
        request: action.payload.request,
        submitLoading: true,
        submitError: null,
        consultationID: "",
      };
    case "UPDATE_CONSULTATION_SUCCESS":
      const { consultationID, consultation } = action.payload;
      const updatedConsultationsUpdate = state.consultations.map(
        (consultationItem) =>
          consultationItem.id === consultation?.id
            ? consultation
            : consultationItem,
      );
      return {
        ...state,
        request: null,
        submitLoading: false,
        consultation: consultation,
        consultationID: consultationID,
        consultations: updatedConsultationsUpdate,
      };
    case "UPDATE_CONSULTATION_ERROR":
      return {
        ...state,
        request: null,
        submitLoading: false,
        submitError: action.error,
      };
    case "CLEAR_EDIT_MESSAGE":
      return {
        ...state,
        editedMessage: {},
      };
    case "CLEAR_SEND_DRAFT_STATUS":
      return {
        ...state,
        sendDraftStatus: "",
      };
    case "CLEAR_UPDATE_CONSULTATION":
      return {
        ...state,
        consultationID: "",
      };
    case "CLEAR_UPDATE_CONSULTATION_ERROR":
      return {
        ...state,
        submitError: null,
      };
    case "REQUEST_GET_ZOOM_TOKEN":
      return {
        ...state,
        request: action.payload.request,
        zoomTokenLoading: true,
        zoomTokenError: null,
        zoomTokenData: null,
      };
    case "SUCCESS_GET_ZOOM_TOKEN":
      return {
        ...state,
        request: null,
        zoomTokenLoading: false,
        zoomTokenData: action.payload.zoomTokenData,
      };
    case "ERROR_GET_ZOOM_TOKEN":
      return {
        ...state,
        request: null,
        zoomTokenLoading: false,
        zoomTokenError: action.error,
      };
    case "REQUEST_GET_RTK_TOKEN":
      return {
        ...state,
        request: action.payload.request,
        rtkTokenLoading: true,
        rtkTokenError: null,
        rtkTokenData: null,
      };
    case "SUCCESS_GET_RTK_TOKEN":
      return {
        ...state,
        request: null,
        rtkTokenLoading: false,
        rtkTokenData: action.payload.rtkTokenData,
      };
    case "ERROR_GET_RTK_TOKEN":
      return {
        ...state,
        request: null,
        rtkTokenLoading: false,
        rtkTokenError: action.error,
      };
    case "CLEAR_RTK_TOKEN":
      return {
        ...state,
        rtkTokenLoading: false,
        rtkTokenError: null,
        rtkTokenData: null,
      };
    default:
      return state;
  }
};
